/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IAddSuggestionMessage extends IMessage {
	id: string;
	documentId: string;
	type: string;
	data: string;
	originalSuggestionId: string | null;
	attributes: string | null;
}

export default class AddSuggestionMessage extends Message {
	public static readonly TYPE: string = '101';

	public static readonly READABLE_TYPE_NAME: string = 'addSuggestion';

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesAddSuggestionMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			type: {
				type: 'string',
				id: 3
			},
			data: {
				type: 'string',
				id: 4
			},
			originalSuggestionId: {
				type: 'string',
				id: 5
			},
			attributes: {
				type: 'string',
				id: 6
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly documentId: string,
		public readonly type: string,
		public readonly data: Record<string, unknown> = {},
		public readonly originalSuggestionId: string | null = null,
		public readonly attributes: Record<string, unknown> | null = null
	) {
		super();
	}

	public toJSON(): IAddSuggestionMessage {
		return {
			id: this.id,
			documentId: this.documentId,
			type: this.type,
			data: JSON.stringify( this.data ),
			originalSuggestionId: this.originalSuggestionId,
			attributes: JSON.stringify( this.attributes )
		};
	}

	public static fromJSON( object: IAddSuggestionMessage ): AddSuggestionMessage {
		return new AddSuggestionMessage(
			object.id,
			object.documentId,
			object.type,
			JSON.parse( object.data ),
			object.originalSuggestionId ?? null,
			object.attributes ? JSON.parse( object.attributes ) : null
		);
	}
}
